import $ from 'jquery';
import _ from 'underscore';

export default class InfoWindow extends google.maps.OverlayView {
  constructor(opts) {
    var defaults = {
      map: null,
      elem: null,
      disableAutoPan: false,
      position: new google.maps.LatLng(0, 0),
      closeOnMapClick: true,
      margin: new google.maps.Size(0, 0),
      offset: new google.maps.Size(0, -10),
      showDebugOverlays: false
    };
    var options = $.extend({}, defaults, opts);

    super(arguments);

    this.options = options;

    if (!_.isArray(options.margin)) {
      options.margin = [options.margin, options.margin];
    }

    this.elem = options.elem;
    this.position = options.position;
    this.opening = false;
    this.eventListeners = [];
    this.moveListener = null;

    if (options.showDebugOverlays) {
      this.rectangle = new google.maps.Rectangle();
    }
  }

  panBox() {
    if (!this.options.disableAutoPan) {
      var map = this.getMap();

      if (map instanceof google.maps.Map) {
        var $map = $(map.getDiv());
        var center = map.getCenter();
        var mapWidth = $map.width();
        var mapHeight = $map.height();
        var iwWidth = this.elem.outerWidth();
        var iwHeight = this.elem.outerHeight();

        var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position);

        var halfWidth = iwWidth / 2;

        var markerEdges = {
          top: ((pixPosition.y - iwHeight) + this.options.offset.height) - this.options.margin[0].height,
          left: ((pixPosition.x - halfWidth) + this.options.offset.width) - this.options.margin[0].width,
          bottom: pixPosition.y + (this.options.margin[1].height / 2),
          right: ((pixPosition.x + halfWidth) + this.options.offset.width) + this.options.margin[1].width
        };

        var ne = this.getProjection().fromContainerPixelToLatLng(
          new google.maps.Point(markerEdges.left, markerEdges.top), true
        );

        var sw = this.getProjection().fromContainerPixelToLatLng(
          new google.maps.Point(markerEdges.right, markerEdges.bottom), true
        );

        var bounds = new google.maps.LatLngBounds(ne, sw);

        if (this.options.showDebugOverlays) {
          var rectOptions = {
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            map: map,
            bounds: bounds
          };
          this.rectangle.setOptions(rectOptions);
        }
        map.panToBounds(bounds);
      }
    }
  }

  onAdd() {
    this.elem.hide();
    this.div = this.elem[0];

    var cancelHandler = function (e) {
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    };

    this.elem.on('mousewheel wheeldown wheel scrollwheel', function(event) {
      event.stopPropagation();
    });

    var events = ["mousedown", "scrollwheel", "mouseover", "wheel", "mousewheel", "wheelup", "wheeldown", "mouseout", "mouseup", "click", "dblclick", "touchstart", "touchend", "touchmove"];

    for (var i = 0; i < events.length; i++) {
      this.eventListeners.push(google.maps.event.addDomListener(this.div, events[i], cancelHandler));
    }

    this.eventListeners.push(google.maps.event.addDomListener(this.div, "mouseover", function (e) {
      this.style.cursor = "default";
    }));

    var panes = this.getPanes();
    panes.floatPane.appendChild(this.div);
  }

  draw() {
    var me = this;

    var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position);

    var offsetX = (this.elem.outerWidth() / 2) + this.options.offset.width;
    var offsetY = this.elem.outerHeight() - this.options.offset.height;

    this.elem.css('left', (pixPosition.x - offsetX) + "px");
    this.elem.css('top', (pixPosition.y - offsetY) + "px");

    if (this.isHidden) {
      this.elem.hide();
    } else {
      this.elem.show();
      if (this.div && this.opening) {
        this.panBox();
        this.opening = false;
      }
    }
  }

  setHTML(html) {
    this.html = html;
    this.updateHTML();
  }

  onRemove() {
    if (this.div) {
      this.elem.remove();
    }
  }

  setPosition(latlng) {
    this.position = latlng;

    if (this.div) {
      this.draw();
    }
    google.maps.event.trigger(this, "position_changed");
  }

  getPosition() {
    return this.position;
  }

  open(map, anchor) {
    var me = this;
    this.opening = true;

    if (anchor) {
      if (this.getPosition() !== anchor.getPosition()) {
        this.position = anchor.getPosition();
        this.moveListener = google.maps.event.addListener(anchor, "position_changed", function () {
          me.setPosition(this.getPosition());
        });
      }
    }
    this.setMap(map);

    if (this.options.closeOnMapClick) {
      this.eventListeners.push(google.maps.event.addListener(map, 'click', function(){
        me.close(map);
      }));
    }

    this.elem.on('click', '.close', function() {
      me.close(map);
    });
  }

  close(map) {
    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }

    if (this.eventListeners) {
      for (var i = 0; i < this.eventListeners.length; i++) {
        google.maps.event.removeListener(this.eventListeners[i]);
      }
      this.eventListeners = [];
    }
    this.setMap(null);

    if (this.options.showDebugOverlays) {
      this.rectangle.setMap(null);
      delete this.rectangle;
    }
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/google/maps/InfoWindow.js
 **/